
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';



export const mobileAppService = {
    mobileInstalledList,
    mobileInstallDateRange
    
 
};



async function  mobileInstalledList() {
    return  apiClient.get(`/external-grocedy/mobile-installed-list`,authHeader());
}



async function  mobileInstallDateRange(data) {
    return  apiClient.post(`/external-grocedy/mobile-install-date-range`,data, authHeader());
}


























